export default {
  height: "auto",
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  menuWidth: 300,
  border: true,
  index: false,
  viewBtn: false,
  delBtn: false,
  addBtn: false,
  editBtn: false,
  selection: true,
  dialogClickModal: false,
  searchLabelWidth: 100,
  column: [
    {
      label: "",
      prop: "id",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "租赁人",
      prop: "name",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
    },
    {
      label: "手机号",
      prop: "phoneNumber",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
    },
    {
      label: "租赁金额",
      prop: "lendingAmount",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
    },
    {
      label: "每月租金",
      prop: "lendingAmountPer",
      type: "input",
      slot: true,
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      type: 'input',
    },
    {
      label: '车辆品牌',
      prop: 'carBrand',
      type: 'input',
    },
    {
      label: "状态",
      prop: "businessStatus",
      type: "select",
      slot: true,
    },
    {
      label: "所属代理商",
      prop: "businessDeptName",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
    },
    {
      label: "所属代理商",
      prop: "businessDeptId",
      type: "tree",
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchClearable: false,
      searchOrder: 2,
      hide: true,
      dicData: [],
      props: {
        label: "title",
      },
    },
  ],
};
